export default {
  OK: 200,
};
